<div
  class="swal2-container swal2-rtl swal2-center swal2-backdrop-show"
  style="overflow-y: auto"
>
  <div
    aria-labelledby="swal2-title"
    aria-describedby="swal2-html-container"
    class="swal2-popup swal2-modal swal2-icon-warning swal2-show"
    tabindex="-1"
    role="dialog"
    aria-live="assertive"
    aria-modal="true"
    style="display: grid"
  >
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex">
      <div class="swal2-icon-content">!</div>
    </div>
    <img class="swal2-image" style="display: none" />
    <h2 class="swal2-title" id="swal2-title" style="display: block">
      {{ inputModel.pageTitle | translate }}
    </h2>
    <div
      class="swal2-html-container"
      id="swal2-html-container"
      style="display: block"
    >
      {{ inputModel.pageMessage | translate }}
    </div>

    <label for="swal2-checkbox" class="swal2-checkbox" style="display: none">
      <input type="checkbox" />
      <span class="swal2-label"> </span>
    </label>
    <div class="swal2-actions">
      <div class="swal2-loader"></div>
      <button
        type="button"
        class="swal2-confirm btn btn-primary me-3"
        style="display: inline-block"
        aria-label=""
        (click)="ok()"
      >
        {{ inputModel.buttonText | translate }}
      </button>
      <button
        type="button"
        class="swal2-deny"
        style="display: none"
        aria-label=""
      >
        {{ "No" | translate }}
      </button>
      <button
        type="button"
        class="swal2-cancel btn btn-label-secondary"
        style="display: inline-block"
        aria-label=""
        (click)="cancel()"
      >
        {{ "Cancel" | translate }}
      </button>
    </div>
    <div class="swal2-footer" style="display: none"></div>
    <div class="swal2-timer-progress-bar-container">
      <div class="swal2-timer-progress-bar" style="display: none"></div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</div>
